import store from "store/store";

export const formSelectors = {
	isFetching: (state = store.getState()) => state.form.isFetching,
	isRefresh: (state = store.getState()) => state.form.isRefresh,
	error: (state = store.getState()) => state.form.error,
	content: (state = store.getState()) => state.form.content,
	entity: (state = store.getState()) => state.form.entity,
	rto: (state = store.getState()) => state.form.rto,
	documentVersion: (state = store.getState()) => state.form.entity.documentVersion,
	savingIndicator: (state = store.getState()) => state.form.entity.savingIndicator,
};
